import {
    HttpResponse,
    UnitOfMeasureModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class UnitOfMeasuresDataService implements CrudService<UnitOfMeasureModel, UnitOfMeasureModel> {
    getAll(query: CrudDataQuery<UnitOfMeasureModel>): Promise<CrudEnumerableResponse<UnitOfMeasureModel>> {
        return ApiService.api.getUnitOfMeasureBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<UnitOfMeasureModel>): Promise<CrudEnumerableResponse<UnitOfMeasureModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<UnitOfMeasureModel>> {
        return ApiService.api.getUnitOfMeasureById(id, params);
    }

    create(item: UnitOfMeasureModel, params?: RequestParams): Promise<CrudResponse<UnitOfMeasureModel>> {
        return ApiService.api.insertUnitOfMeasure(item, params);
    }

    update(item: UnitOfMeasureModel, params?: RequestParams): Promise<UnitOfMeasureModel> {
        return ApiService.api.updateUnitOfMeasure(item.id as Required<string>, item, params).then((req: any) => req.data.returnValue);
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<UnitOfMeasureModel> {
        return ApiService.api.patchUnitOfMeasure(id, patches, params).then((req: any) => req.data.returnValue);
    }

    delete(query: CrudDataQuery<UnitOfMeasureModel>): Promise<CrudEnumerableResponse<UnitOfMeasureModel>> {
        return ApiService.api.deleteUnitOfMeasures(<any>query.data, query.params).then((req: any) => req.data.returnValue);
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        return ApiService.api.aggregationUnitOfMeasure(query, params).then((req: any) => req.data.returnValue);
    }

    download(query: CrudDataQuery<UnitOfMeasureModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: UnitOfMeasureModel, params?: RequestParams): Promise<CrudResponse<UnitOfMeasureModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        return ApiService.api.getUnitOfMeasureGroupped(query, params);
    }

}
